<template >
  <div class="widget">
    <Tabs value="iview" :animated="false">
      <TabPane label="iview" name="iview">
        <div class="icon-search">
          <input
            type="text"
            :placeholder="searchPlaceholder"
            @focus="changeHolder('focus')"
            @blur="changeHolder('blur')"
            v-model="search">
        </div>
        <m-divider ></m-divider>
        <div class="icons">
          <div class="icons-item" v-for="(item,index) in filterIcons"  @mouseover="showClipBtn(index)"
               @mouseleave="isShow = -1">
            <i class="ivu-icon" :class="[`ivu-icon-${item.name}`]" style="font-size:32px"></i>
            <p>
              {{ item.name }}
            </p>
            <div class="btn-bar" v-if="isShow === index">
              <div class="btn">
                <Button size="small" type="info" @click="clip(item,'code','icon')">code</Button>
                <Button size="small" style="margin-left: 10px" @click="clip(item,'class','icon')">class</Button>
              </div>
            </div>
          </div>
        </div>
      </TabPane>
      <TabPane label="iconfont" name="iconfont">
        <div class="icon-search">
          <input
            type="text"
            :placeholder="searchPlaceholder"
            @focus="changeHolder('focus')"
            @blur="changeHolder('blur')"
            v-model="searchIcon">
        </div>
        <m-divider ></m-divider>
        <div class="icons">
          <div class="icons-item" v-for="(item,index) in filterIconfonts"  @mouseover="showClipBtn(index)"
               @mouseleave="isShow = -1">
            <i class="ivu-icon-iconfont" :class="[`icon${item.name}`]" style="font-size:32px"></i>
            <p style="padding-top: 0px;  word-wrap: break-word;word-break: break-all;overflow: hidden;">
              {{ item.name }}
            </p>
            <div class="btn-bar" v-if="isShow === index">
              <div class="btn">
                <Button size="small" type="info" @click="clip(item,'code','iconfont')">code</Button>
                <Button size="small" style="margin-left: 10px" @click="clip(item,'class','iconfont')">class</Button>
              </div>
            </div>
          </div>
        </div>
      </TabPane>
      <TabPane label="png16" name="png16">
        <div class="icon-search">
          <input
            type="text"
            :placeholder="searchPlaceholder"
            @focus="changeHolder('focus')"
            @blur="changeHolder('blur')"
            v-model="search16">
        </div>
        <m-divider ></m-divider>
        <div class="icons">
          <div class="icons-item" v-for="(item,index) in filterPng16"  @mouseover="showClipBtn(index)"
               @mouseleave="isShow = -1">
            <i class="ivu-img-16" :class="[`ivu-img-${item.name}`]"></i>
            <p>
              {{ item.name }}
            </p>
            <div class="btn-bar" v-if="isShow === index">
              <div class="btn">
                <Button size="small" type="info" @click="clip(item,'code','img16')">code</Button>
                <Button size="small" style="margin-left: 10px" @click="clip(item,'class','img16')">class</Button>
              </div>
            </div>
          </div>
        </div>
      </TabPane>
      <TabPane label="png22" name="png22">
      </TabPane>
      <TabPane label="png24" name="png24">标签三的内容</TabPane>
      <TabPane label="png32" name="png32">标签三的内容</TabPane>
    </Tabs>
  </div>
</template>

<script>
  import Icons from '@code/iconname';
  import iconfonts from '@code/iconfont';
  import Png16 from '@code/smallImgName';
  import Clipboard from 'clipboard';
  import mDivider from '@components/divider/m-divider'
  const searchPlaceholder = '输入英文关键词搜索，比如 success';
    export default {
      components:{mDivider},
      data(){
          return{
            searchPlaceholder: searchPlaceholder,
            search: '',
            searchIcon:'',
            search16:'',
            icons: Icons,
            iconfont:iconfonts,
            png16:Png16,
            isShow:-1,
          }
      },
      created(){

      },
      computed: {
        filterIcons () {
          return this.icons.filter(icon => icon.tag.indexOf(this.search) > -1);
        },
        filterPng16 () {
          return this.png16.filter(icon => icon.tag.indexOf(this.search16) > -1);
        },
        filterIconfonts (){
          return this.iconfont.filter(icon => icon.tag.indexOf(this.searchIcon) > -1);
        }
      },
      methods:{
        changeHolder (type) {
          if (type === 'focus') {
            this.searchPlaceholder = '';
          } else if (type === 'blur') {
            this.searchPlaceholder = searchPlaceholder;
          }
        },
        showClipBtn(index){
          this.isShow = index;
        },
        clip (item,btnType,type) {
          const clipboard = new Clipboard('.icons', {
            text () {
           if(btnType==='code'){
             switch (type) {
               case('icon'):return `<Icon type="${item.name}" />`;
               case('img16'):return `<Icon type="img ivu-img-16 ivu-img-${item.name}" />`;
               case('iconfont'): return `<Icon type="iconfont icon${item.name}" />`;
             }
           }else if(btnType==='class'){
             switch (type) {
               case('icon'):return item.name;
               case('img16'):return `img ivu-img-16 ivu-img-${item.name}`;
               case('iconfont'): return `iconfont ivu-icon-iconfont icon${item.name}`;
             }
           }
            }
          });
          clipboard.on('success', (e) => {
            e.clearSelection();
            clipboard.destroy();
            if(e.text.indexOf('<Icon') !==-1){
              this.$Message.success('组件代码已经复制到剪贴板');
            }else{
              this.$Message.success('图标名称已经复制到剪贴板');
            }
          });
        },
      }
    }
</script>

<style scoped>
  .widget{
    margin: 5px;
  }
  .widget /deep/ .ivu-tabs-bar {
    border-bottom: 1px solid #cdcdcd;
    box-shadow: 0 1px 0 #fff;
    -webkit-box-shadow: 0 1px 0 #fff;
    -moz-box-shadow: 0 1px 0 #fff;
    text-shadow: 0 1px #fff;
    -webkit-border-top-right-radius: 3px;
    -webkit-border-top-left-radius: 3px;
    -moz-border-radius-topright: 3px;
    -moz-border-radius-topleft: 3px;  position: relative;
    color: #636363;
    background: #f8f8f8;
    background: -moz-linear-gradient(to bottom,  #f8f8f8 0%, #e8e8e8 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#f8f8f8), color-stop(100%,#e8e8e8));
    background: -webkit-linear-gradient(to bottom,  #f8f8f8 0%,#e8e8e8 100%);
    background: -o-linear-gradient(to bottom,  #f8f8f8 0%,#e8e8e8 100%);
    background: -ms-linear-gradient(to bottom,  #f8f8f8 0%,#e8e8e8 100%);
    background: linear-gradient(to bottom,  #f8f8f8 0%,#e8e8e8 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f8f8f8', endColorstr='#e8e8e8',GradientType=0 );
  }
  .widget /deep/ .ivu-tabs-nav .ivu-tabs-tab{
    margin-right: 0;
    border-right: 1px solid #cdcdcd;
  }
  .widget /deep/ .ivu-tabs-ink-bar{
    height: 0;
    background-color: transparent;
  }
  .widget /deep/ .ivu-tabs-nav .ivu-tabs-tab-active{
    color: #797979;
    background: #f9f9f9;
    box-shadow: 0 -1px 0 #EAEAEA inset;
    border-bottom: 1px solid #EAEAEA;
  }
  .widget /deep/ .ivu-tabs-nav .ivu-tabs-tab:hover{
    color: #797979;
  }
  .widget /deep/  .ivu-tabs-nav-container:focus .ivu-tabs-tab-focused {
     border-color: #cdcdcd !important;
  }
  /*.widget /deep/ .ivu-tabs-tabpane{
    height: calc(100vh - 113px);
  }*/
  .icon-search{
    position: relative;
    margin: 0 auto;
    text-align: center;
  }
  .icon-search input {
    width: 500px;
    box-sizing: border-box;
    background: #fdfdfd;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    outline: none;
    margin: 0 auto;
    padding: 8px 0;
    border: 1px solid  #d7d7d7;
  }
  .icons{
     overflow: auto;
     zoom: 1;
     padding-left: 10px;
    height: calc(100vh - 204px);
   }
  .icons-item{
    float: left;
    margin: 3px 3px 6px 0;
    width: 130px;
    text-align: center;
    list-style: none;
    cursor: pointer;
    height: 100px;
    color: #5c6b77;
    transition: all .2s ease;
    position: relative;
    padding-top: 10px;
  }
  .icons-item p{
    padding-top: 15px;
  }
  .btn-bar{
    position: absolute;
    background: #dee1e25e;
    width: 130px;
    height: 115px;
    border-radius: 10px;
    top:0;
  }
  .btn{
    margin-top: 80px;
  }
</style>
